module.exports = __webpack_public_path__ + "images/edm_triple_header.jpg";


//////////////////
// WEBPACK FOOTER
// ./vively/images/email/edm_triple_header.jpg
// module id = 870
// module chunks = 3